export default "__VITE_ASSET__ym4JDP0s__"